export default {
  'resetpassword.maintext':
    ' To reset your password please enter the new password in both fields',
  'resetpassword.retypepassword': 'Retype Password',
};
